/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of a single application on the device.
 */
export enum ApplicationStatusType {
  ApplicationStatusPreparing = 'Preparing',
  ApplicationStatusStarting = 'Starting',
  ApplicationStatusRunning = 'Running',
  ApplicationStatusError = 'Error',
  ApplicationStatusUnknown = 'Unknown',
  ApplicationStatusCompleted = 'Completed',
  ApplicationStatusStopped = 'Stopped',
  ApplicationStatusStopping = 'Stopping',
}
